module.exports = __webpack_public_path__ + "static/2011_pfeil_throwable-panoramic-ball-camera_demo-abstract.40de8b8d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/download/2011_pfeil_throwable-panoramic-ball-camera_demo-abstract.pdf
// module id = 292
// module chunks = 126093192170660